import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';
import {FirebaseAuthManager} from '../../data/manager/customer/firebase-auth/firebase-auth.manager';
import {RegistrationExpressMg} from 'src/app/data/manager/registration-express/registration-express.manager';
import {iDocumentTypesResponse} from 'src/app/data/networking/models/registration-express/registration-express';

import { FirebaseManager } from 'src/app/data/manager/firebase/firebase.manager';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';

@Injectable({
  providedIn: 'root',
})
export class SignUpFormVm {
  constructor (
    private customerManager: CustomerManager,
    private firebaseAuthManager: FirebaseAuthManager,
    private localStorageManager: LocalStorageManager,
    private registrationExpressMg: RegistrationExpressMg,
    private firebaseManager: FirebaseManager,
  ) {}

  validateCustomer(params): Observable<any> {
    return this.customerManager.validateCustomer(customerTransformer(params));
  }

  createCustomer(data, formComplete): Observable<any> {
    return this.customerManager.create(data, false, formComplete);
  }

  fetchFirebaseData(data): Observable<any> {
    return this.firebaseAuthManager.fetchFirebaseData(data, true);
  }

  validateSmsToken(data): Observable<any> {
    return this.customerManager.validateSmsToken(data);
  }

  getCustomerOrigin(params): Observable<any> {
    return this.customerManager.getCustomerOrigin(params);
  }

  getLocalStorage(item) {
    return this.localStorageManager.get(item);
  }

  mergeCarts(idCustomerWebSafeAnonymous): Observable<any> {
    return this.customerManager.mergeCarts(this.localStorageManager.get('customer'), idCustomerWebSafeAnonymous);
  }
  
  getDocumentTypes(): Observable<iDocumentTypesResponse[]> {
    return this.registrationExpressMg.documentTypes();
  }

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }

}


function customerTransformer(data) {
  const phone = !!data.phoneCode ? `${data.phoneCode}${data.phone}` : data.phone;
  return {...data, phone};
}
